// import { resolveInternalLink } from "@/lib/helpers";
// import Link from "next/link";
// import { useMemo } from "react";
// import { PrimaryButton, SecondaryButton } from "../styles";

import AppLinkComponent, { AppLinkProps } from "@/components/AppLink";
import {
  PrimaryButton as PrimaryButtonStyled,
  SecondaryButton as SecondaryButtonStyled,
} from "../styles";

// Cast to fix React 17 + @types/react 18 compatibility issue
const AppLink = AppLinkComponent as any;
const PrimaryButton = PrimaryButtonStyled as any;
const SecondaryButton = SecondaryButtonStyled as any;

export type InternalLinkProps = AppLinkProps & {
  _type: "internalLink";
  title: string;
  index: number;
};

/** @deprecated */
const InternalLink: React.FC<InternalLinkProps> = (props) => {
  const { title, page, index, params } = props;
  if (!title) return null;

  return (
    <AppLink page={page} params={params}>
      {index && index > 0 ? (
        <SecondaryButton>{title}</SecondaryButton>
      ) : (
        <PrimaryButton>{title}</PrimaryButton>
      )}
    </AppLink>
  );
};

export default InternalLink;
